(function () {
  'use strict';
  if (window.healthyBookingSummary) return;
  window.healthyBookingSummary = true;
  function init(scope) {
    scope.querySelectorAll('[data-booking-summary]').forEach(summary => {
      if (summary.dataset.initialized) return;
      summary.dataset.initialized = 'true';
      const root = summary.closest('.self-booking');
      const guestField = root.querySelector('[name="estimatedGuestCount"]');
      const packagePanel = root.querySelector('[data-booking-packages]');
      let previousNotes = '';
      function render() {
        let quote;
        try { quote = JSON.parse(sessionStorage.getItem('healthy-italia:event-quote:v2')); } catch (_) {}
        const valid = quote && Date.now() - quote.savedAt < 7200000 && Number.isInteger(quote.headcount) && quote.headcount > 0 && quote.totals && ['base','guests','addons','subtotal','service','tax','total','each'].every(key => Number.isFinite(quote.totals[key])) && [...root.querySelectorAll('[name="menu"]')].some(input => input.value === quote.packageName);
        summary.querySelector('[data-summary-content]').hidden = !valid;
        summary.querySelector('[data-summary-empty]').hidden = !!valid;
        if (packagePanel) packagePanel.hidden = !!valid;
        if (guestField) guestField.readOnly = !!valid;
        if (!valid) return;
        let format;
        try { format = new Intl.NumberFormat('en-US', {style:'currency',currency:quote.currency || 'USD'}); } catch (_) { format = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}); }
        const money = value => format.format(value / 100);
        summary.querySelector('[data-summary-package]').textContent = quote.packageTitle || quote.packageName;
        summary.querySelector('[data-summary-guests]').textContent = quote.headcount;
        summary.querySelector('[data-summary-included]').textContent = quote.packageDetail || '';
        summary.querySelectorAll('[data-summary-total]').forEach(el => { el.textContent = money(quote.totals[el.dataset.summaryTotal]); });
        summary.querySelectorAll('[data-summary-rate]').forEach(el => {
          const rate = el.dataset.summaryRate === 'service' ? quote.serviceRate : el.dataset.summaryRate === 'tax' ? quote.taxRate : null;
          el.textContent = rate == null ? '' : ' (' + rate + '%)';
        });
        const extras = summary.querySelector('[data-summary-extras]'); extras.replaceChildren();
        const lines = Array.isArray(quote.extraDetails) ? quote.extraDetails : quote.totals.lines || [];
        lines.forEach(line => {
          const li = document.createElement('li');
          const description = document.createElement('span');
          description.textContent = line.title;
          if (line.quantity != null) {
            const detail = document.createElement('span'); detail.className = 'booking-summary__extra-detail';
            detail.textContent = line.quantity + ' × ' + money(line.unitAmount); description.append(detail);
          }
          const amount = document.createElement('strong'); amount.className = 'booking-summary__extra-amount'; amount.textContent = money(line.amount);
          li.append(description, amount);
          extras.append(li);
        });
        summary.querySelector('[data-summary-no-extras]').hidden = lines.length > 0;
        if (guestField) guestField.value = quote.headcount;
        root.querySelectorAll('[name="menu"]').forEach(input => { input.checked = input.value === quote.packageName; });
        const notes = root.querySelector('[name="notes"]');
        if (notes && (!notes.value || notes.value === previousNotes)) notes.value = String(quote.notes || '').slice(0,2000);
        previousNotes = String(quote.notes || '').slice(0,2000);
        guestField?.dispatchEvent(new Event('change',{bubbles:true}));
      }
      render();
      window.addEventListener('pageshow',render);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
